<script setup lang="ts">
defineProps<{ description: string[] }>();
</script>

<template>
    <div>
        <p class="title">专属魂印</p>
        <p v-for="line in description" v-html="line"></p>
    </div>
</template>

<style scoped>
div {
    border-radius: calc(var(--ui-unit) * 5);
}

div p {
    font-size: calc(var(--ui-unit) * 14);
    margin: 0;
    padding-left: 0.5em;
    padding-right: 0.5em;
    padding-bottom: 0.5em;
    width: min(calc(var(--ui-unit) * 480), calc(var(--stage-width) - calc(var(--ui-unit) * 48)));
    box-sizing: border-box;
    height: auto;
    text-align: left;
    display: block;
}

div .title {
    padding-top: 0.5em;
    font-weight: bold;
    font-size: calc(var(--ui-unit) * 16);
    color: gold;
}
</style>